import * as THREE from 'three';

export function flat(lat: number, lon: number, z = 0) {
  return new THREE.Vector3(lon / 180, lat / 180, z);
}
